import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button,Modal } from "antd";

export const FireBaseNotificationModel = ({
  showfireBaseNotification,
  setShowFireBaseNotification,
  onConfirm, // callback when user clicks Yes
  setAllUser,
  setShowAddItemModal
}: any) => {
  const handleSubmit = () => {
    setAllUser('allUser')
  }
  
return (
    <Modal
      open={showfireBaseNotification}
      footer={null}
      closable
      centered
      onCancel={() => setShowFireBaseNotification(false)}
    >
      <div style={{ textAlign: "center", padding: "10px 0" }}>

        {/* Icon */}
        <ExclamationCircleFilled style={{ fontSize: 40, color: "#ff4d4f" }} />
        {/* Title */}
        <h3 style={{ marginTop: 16, fontWeight: 600 }}>
          Send a Firebase Notification!
        </h3>
        {/* Description */}
        <p style={{ color: "#666", marginTop: 8 }}>
          Do you want to send this notification to all customers?
        </p>

        {/* Buttons */}
        <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 10 }}>
          {/* <Button onClick={() => setShowFireBaseNotification(false)}>
            No
          </Button> */}

          <Button
            type="primary"
            danger
            onClick={() => {
              onConfirm?.(); // existing callback
              handleSubmit(); // setAllUser('allUser')
              

              setShowAddItemModal(true); // ✅ OPEN your Add Modal

              setShowFireBaseNotification(false); // close current modal
            }}
          >
            Proceed 
          </Button>
        </div>
      </div>
    </Modal>
  );
};